const KEY = 'gA_b00k!nG_2026#';

function xorCipher(text, key) {
  let out = '';
  for (let i = 0; i < text.length; i++) {
    out += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return out;
}

function toBase64Url(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(b64) {
  let s = b64.replace(/-/g, '+').replace(/_/g, '/');
  while (s.length % 4) s += '=';
  return atob(s);
}

export function encryptBookingParams(params) {
  try {
    const json = JSON.stringify(params);
    const ciphered = xorCipher(json, KEY);
    return toBase64Url(unescape(encodeURIComponent(ciphered)));
  } catch {
    return '';
  }
}

export function decryptBookingParams(token) {
  try {
    const ciphered = decodeURIComponent(escape(fromBase64Url(token)));
    const json = xorCipher(ciphered, KEY);
    return JSON.parse(json);
  } catch {
    return null;
  }
}
